import moment from 'moment'

export default {
  methods: {
    formatZhDate(time) {
      return moment(time).format('YYYY年MM月DD日')
    },
    formatTime(time) {
      const timestamp = moment(time).format('X')
      const mistiming = Math.round(new Date() / 1000) - timestamp
      if (mistiming > 604800) {
        return moment(time).format('YYYY-MM-DD HH:mm')
      } else {
        const zhStr = ['天', '小时', '分钟', '秒']
        const step = [86400, 3600, 60, 1]

        for (let i = 0; i < 4; i++) {
          const inm = Math.floor(mistiming / step[i])
          if (inm !== 0) {
            return inm + zhStr[i] + '前'
          }
        }
      }
    }
  }
}
